// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__2-5S2","danger":"Input_danger__KRM78"};